"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelWithIcon = void 0;
var react_1 = __importDefault(require("react"));
var simple_1 = require("../simple");
var techsee_base_component_1 = require("../../../_shared/techsee-base-component");
var simple_icon_1 = require("../../../icons/simple-icon/");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
require("./styles.scss");
var LabelWithIcon = (function (_super) {
    __extends(LabelWithIcon, _super);
    function LabelWithIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelWithIcon.prototype.renderInternal = function () {
        this.addCssClass('label-with-icon');
        this.addCssClass(this.props.className);
        var _a = this.props, children = _a.children, labelFor = _a.labelFor, text = _a.text;
        return (react_1.default.createElement("div", { className: this.renderCssClasses() },
            react_1.default.createElement(simple_icon_1.Icon, { iconName: this.props.icon }),
            (0, isEmpty_1.default)(text) && react_1.default.createElement(simple_1.SimpleLabel, { labelFor: labelFor }, children),
            !(0, isEmpty_1.default)(text) && react_1.default.createElement("span", { className: 'text' }, text)));
    };
    return LabelWithIcon;
}(techsee_base_component_1.TechseeBaseComponent));
exports.LabelWithIcon = LabelWithIcon;
